import React from 'react';

const TAG_PATTERN = /\[([/]?)(b|i|u|s|ul|ol|li|quote|url)(?:=([^\]]+))?\]/gi;

const parseBBCode = (text = '') => {
  const root = { tag: 'root', children: [] };
  const stack = [root];
  let cursor = 0;
  let match;

  while ((match = TAG_PATTERN.exec(text)) !== null) {
    if (match.index > cursor) {
      stack[stack.length - 1].children.push(text.slice(cursor, match.index));
    }

    const closing = match[1] === '/';
    const tag = match[2].toLowerCase();

    if (closing) {
      if (stack.length > 1 && stack[stack.length - 1].tag === tag) {
        stack.pop();
      } else {
        stack[stack.length - 1].children.push(match[0]);
      }
    } else {
      const node = { tag, attribute: match[3]?.trim(), children: [] };
      stack[stack.length - 1].children.push(node);
      stack.push(node);
    }

    cursor = TAG_PATTERN.lastIndex;
  }

  if (cursor < text.length) {
    stack[stack.length - 1].children.push(text.slice(cursor));
  }

  return root.children;
};

const plainText = (children) => children.map(child => (
  typeof child === 'string' ? child : plainText(child.children)
)).join('');

const renderText = (value, key) => {
  const lines = value.split('\n');
  return lines.flatMap((line, index) => (
    index === lines.length - 1
      ? [line]
      : [line, <br key={`${key}-br-${index}`} />]
  ));
};

const renderNode = (node, key) => {
  if (typeof node === 'string') {
    return renderText(node, key);
  }

  const children = node.children.flatMap((child, index) => renderNode(child, `${key}-${index}`));
  const elements = {
    b: 'strong',
    i: 'em',
    u: 'u',
    s: 's',
    ul: 'ul',
    ol: 'ol',
    li: 'li',
    quote: 'blockquote'
  };

  if (node.tag === 'url') {
    const href = node.attribute || plainText(node.children).trim();
    if (!/^https?:\/\//i.test(href)) {
      return children;
    }
    return (
      <a key={key} href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return React.createElement(elements[node.tag] || React.Fragment, { key }, children);
};

const BBCodeText = ({ text, className = '' }) => (
  <div className={className}>
    {parseBBCode(text).flatMap((node, index) => renderNode(node, `bb-${index}`))}
  </div>
);

export default BBCodeText;
